import { FC } from "react";
import moment from "moment";
import {
  Control,
  Controller,
  FieldValues,
  UseFieldArrayAppend,
  UseFieldArrayRemove,
  UseFormRegister,
} from "react-hook-form";
import { Col, Row } from "antd";
import {
  FormBlock,
  FormField,
  ISelect,
  IButton,
  IRangePicker,
  ITooltip,
} from "../../../ui-kit";
import { TrashIco, PlusIco } from "../../../assets/customIcons";
import { EventNotificationTypeMapping } from "../../../constants/Data";

import styles from "../SmsSettings.module.scss";
import Constants from "../../../constants/Common";
import { SmsSettingClientGroupClientType } from "../SmsSettingsDistribution";

interface ISmsSettingsListFormUsers {
  register: UseFormRegister<FieldValues>;
  control: Control<FieldValues, any>;
  fields: Array<SmsSettingClientGroupClientType & { uuid: string }>;
  append: UseFieldArrayAppend<SmsSettingClientGroupClientType>;
  remove: UseFieldArrayRemove;
  watch: FieldValues;
}

const SmsSettingsListFormUsers: FC<ISmsSettingsListFormUsers> = ({
  register,
  control,
  fields,
  append,
  remove,
  watch,
}) => {
  const removeClient = (index) => {
    remove(index);
  };
  const {
    titleIcons: { trash },
  } = Constants;

  const addClient = () => {
    append({});
  };

  return (
    <FormBlock type="easy">
      <Row gutter={15} className="form-block__data-header">
        <Col span={6}>
          <strong>Сотрудник</strong>
        </Col>
        <Col span={4}>
          <strong>Вид уведомления</strong>
        </Col>
        <Col span={4}>
          <strong>Email</strong>
        </Col>
        <Col span={3}>
          <strong>Телефон</strong>
        </Col>
        <Col span={6}>
          <strong>Периоды</strong>
        </Col>
      </Row>
      {fields.map((field, index) => (
        <Row key={field.id} gutter={15} className="form-block__data-row">
          <Col span={6}>
            <FormField
              currentValue={field.name}
              id="clientsName"
              name={`clients.${index}.name`}
              register={register}
              type="text"
            />
          </Col>
          <Col span={4}>
            <Controller
              control={control}
              name={`clients.${index}.notificationType`}
              render={({ field }) => (
                <ISelect
                  field={field}
                  optionsArr={EventNotificationTypeMapping}
                  placeholder="Вид уведомления"
                />
              )}
            />
          </Col>
          <Col span={4}>
            <FormField
              currentValue={field.email}
              id="clientsEmail"
              name={`clients.${index}.email`}
              register={register}
              type="email"
            />
          </Col>
          <Col span={3}>
            <FormField
              currentValue={field.phoneNumber}
              id="clientsTel"
              name={`clients.${index}.phoneNumber`}
              register={register}
              type="tel"
              maskPlaceholder="7"
            />
          </Col>
          <Col span={6}>
            <Controller
              control={control}
              name={`clients.${index}.date`}
              defaultValue={[
                field.from ? moment(field.from) : null,
                field.to ? moment(field.to) : null,
              ]}
              render={({ field }) => <IRangePicker field={field} />}
            />
          </Col>
          <Col>
            <ITooltip title={trash} placement="right">
              <button
                className="form-block__text-button"
                onClick={(e) => removeClient(index)}
                type="button"
              >
                <TrashIco />
              </button>
            </ITooltip>
          </Col>
        </Row>
      ))}
      <Row gutter={15} className="form-block__data-header" align="middle">
        <Col span={24} className={styles.SmsSettingsFormButton}>
          <IButton onClick={(e) => addClient()} type="button" size="medium">
            <PlusIco /> <span>Добавить сотрудника</span>
          </IButton>
        </Col>
      </Row>
    </FormBlock>
  );
};

export default SmsSettingsListFormUsers;
